import styled from 'styled-components'

// Components

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;

  :not(:last-child) {
    margin-top: 32px;
  }
`

export const Line = styled.div`
  width: 100%;
  margin-top: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
`
